import { render } from "./HomeDash.vue?vue&type=template&id=8d53c22c&scoped=true"
import script from "./HomeDash.vue?vue&type=script&lang=js"
export * from "./HomeDash.vue?vue&type=script&lang=js"

import "./HomeDash.vue?vue&type=style&index=0&id=8d53c22c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d53c22c"]])

export default __exports__